export const ALL_CITY_REQUEST = 'ALL_CITY_REQUEST'
export const ALL_CITY_SUCCESS = 'ALL_CITY_SUCCESS'
export const ALL_CITY_FAIL = 'ALL_CITY_FAIL'

export const SUB_DISTRICT_REQUEST = 'SUB_DISTRICT_REQUEST'
export const SUB_DISTRICT_SUCCESS = 'SUB_DISTRICT_SUCCESS'
export const SUB_DISTRICT_FAIL = 'SUB_DISTRICT_FAIL'
export const SUB_DISTRICT_RESET = 'SUB_DISTRICT_RESET'